import { Component, OnInit, ViewChild } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { MatStepper } from "@angular/material/stepper";
import { NavigationEnd, Router } from "@angular/router";
import { registerService } from "src/app/shared/services/register-person.service";
import Swal from "sweetalert2";
import { dataService } from "../../service/data.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { AnexoJuridicoComponent } from "./anexo-juridico/anexo-juridico.component";
import { InformacionPatrimonialJuridico, InformacionPatrimonialJuridicoData, OperacionesDelClienteJuridico, OperacionesDelClienteJuridicoData, VinculadaAlClienteJuridicoData } from "./interface/JuridicasInterface";

@Component({
  selector: "app-form-tree",
  templateUrl: "./form-tree.component.html",
  styleUrls: ["./form-tree.component.scss"],
})
export class FormTreeComponent implements OnInit {
  @ViewChild("stepper") private myStepper: MatStepper;

  mostrarFirmas;
  distritosPersonaAutorizada;
  distritoPersonaAutorizada
  departamentoPersonaAutorizada;
  provinciaPersonaAutorizada;
  provinciasPersonaAutorizada;
  departamentos;
  provincias;
  departamento;
  distritos: any[];
  provincia;
  distrito;
  boxingExposedPersonOptions;
  boxingIsProxy;
  isLoadinData: Boolean = true;
  showBtnAccesoFirmaJuridico: Boolean = false;

  isLoadingDataIdentificacionDelCliente: Boolean = true;

  showIdentificacionDelCliente = false;


  /**
   * Variables operaciones del cliente.
   */
  showStepOperacionesDelClienteJuridico = false;
  operacionesDelClienteJuridicoQuestions: OperacionesDelClienteJuridicoData = {
    busca_alternativas_financiamiento: "question_alternativas_de_financiamiento",
    estado_cuenta_e_informacion_operaciones: "question_acceso_estado_de_cuenta_e_informacion_de_operaciones",
    modalidad_envio_ordenes: "question_modalidad_de_envio_de_ordenes",
    tipos_de_operaciones_a_realizar: "question_tipos_operacion_realizar"
  }
  operacionesDelClienteJuridicoData: OperacionesDelClienteJuridico;
  operacionesDelClienteFormGroup: FormGroup



  /**
   * Variables informacion patrimonial.
   */
  showStepInformacionPatrimonial = false;
  informacionPatrimonialQuestions: InformacionPatrimonialJuridicoData = {
    inf_financiera_ultimo_ejercicio: "question_financiera_ultimo_ejercicio",
    ingreso_promedio_mensual: "question_ingreso_promedio_mensual",
    procedencia_fondos: "question_procedencia_fondos",
    usted_o_accionistas_investigado_delito: "question_usted_o_accionistas_investigado_por_delito"
  }
  informacionPatrimonialData: InformacionPatrimonialJuridico;
  informacionPatrimonialFormGroup: FormGroup;


  /**
   * Variables vinculados al cliente.
   */

  showStepVinculadosAlCliente = false;
  vinculadosAlClienteFormGroup: FormGroup;
  vinculadosAlClienteData: VinculadaAlClienteJuridicoData;
  vinculadosAlClienteQuestions: VinculadaAlClienteJuridicoData = {
    informacion_vinculados_al_cliente: {
      apellidos: "question_apellidos",
      expuesto_politicamente_o_pertenece_pep: "question_apellidos_expuesto_politicamente_o_pertenece_pep",
      fecha_nacimiento: "question_fecha_nacimiento",
      nacionalidad: "question_nacionalidad",
      nombre_o_razon_social: "question_nombre_o_razon_social",
      nro_documento: "question_nro_documento",
      pais_residencia: "question_pais_residencia",
      participacion: "question_participacion",
      tipo_documento: "question_tipo_documento"


    },
    relacion_personas_juridicas_vinculadas_al_cliente: ""
  }


  showPersonasAutorizadas = false;



  constructor(
    private sdata: dataService,
    private _Register: registerService,
    private _formBuilder: FormBuilder,
    private _router: Router,
    private modalService: NgbModal
  ) {
    setTimeout(() => {
      this._Register.estadodelFormulario().subscribe((res) => {

        if (res.indiceFormulario == "CUSTOMER_IDENTIFICATION_LEGAL") {
          this.showIdentificacionDelCliente = true;
          this.apa3 = true;
          setTimeout(() => {
            this.move(1);
          }, 5);
        }
        if (res.indiceFormulario == "CUSTOMER_ACTIVITY_LEGAL") {
          this.showIdentificacionDelCliente = true;

          this.apa3 = true;
          this.showStepOperacionesDelClienteJuridico = true;
          setTimeout(() => {
            this.move(2);
          }, 5);
        }

        if (res.indiceFormulario == "CUSTOMER_OPERATION_LEGAL") {
          this.showIdentificacionDelCliente = true;

          this.apa3 = true;
          this.showStepOperacionesDelClienteJuridico = true;
          this.showStepInformacionPatrimonial = true;

          setTimeout(() => {
            this.move(3);
          }, 5);
        }

        if (res.indiceFormulario == "PATRIMONIAL_INFORMATION_FUNDS_LEGAL") {
          this.showIdentificacionDelCliente = true;

          this.apa3 = true;

          this.showStepOperacionesDelClienteJuridico = true;
          this.showStepInformacionPatrimonial = true;
          this.showStepVinculadosAlCliente = true;


          setTimeout(() => {
            this.move(4);
            //            this.estAnexo = true;
            //            this.abrirAnexo();
          }, 5);
        }

        if (res.indiceFormulario == "LINKED_TO_THE_CUSTOMER_LEGAL") {
          this.showIdentificacionDelCliente = true;

          this.apa3 = true;

          this.showStepOperacionesDelClienteJuridico = true;
          this.showStepInformacionPatrimonial = true;
          this.showStepVinculadosAlCliente = true;
          this.showPersonasAutorizadas = true;

          setTimeout(() => {
            this.move(5);
            //            this.estAnexo = true;
            //            this.abrirAnexo();
          }, 5);
        }





        if (res.indiceFormulario == "DJ_TAX_RESIDENCE_ANNEX_LEGAL") {
          this.showIdentificacionDelCliente = true;

          this.apa3 = true;
          this.apa4 = true;
          this.apa5 = true;
          this.showStepOperacionesDelClienteJuridico = true;
          this.showStepInformacionPatrimonial = true;
          this.showStepVinculadosAlCliente = true;

          setTimeout(() => {
            this.move(5);
            this.estAnexo = true;
            this.abrirAnexo();
          }, 5);
        }

        if (res.indiceFormulario == "DJ_PEP_ANNEX_LEGAL") {
          this.showIdentificacionDelCliente = true;

          this.apa3 = true;
          this.apa4 = true;
          this.apa5 = true;
          this.showStepOperacionesDelClienteJuridico = true;
          this.showStepInformacionPatrimonial = true;
          this.showStepVinculadosAlCliente = true;


          setTimeout(() => {
            this.move(6);
            this.estAnexo = true;
            this.abrirAnexo();
          }, 5);
        }

        if (res.indiceFormulario == "AUTHORIZED_PERSONS_LEGAL") {
          this.showIdentificacionDelCliente = true;


          this.apa3 = true;
          this.apa4 = true;
          this.apa5 = true;
          this.showStepOperacionesDelClienteJuridico = true;
          this.showStepInformacionPatrimonial = true;
          this.showStepVinculadosAlCliente = true;
          this.showPersonasAutorizadas = true;


          setTimeout(() => {
            this.move(5);
            this.estAnexo = false;
            this.abrirAnexo();
          }, 5);
        }



        if (res.indiceFormulario == "DJ_INSTITUTIONAL_INVESTOR_ANNEX_LEGAL") {
          this.showIdentificacionDelCliente = true;

          this.apa3 = true;
          this.apa4 = true;
          this.apa5 = true;
          this.showStepOperacionesDelClienteJuridico = true;
          this.showStepInformacionPatrimonial = true;
          this.showStepVinculadosAlCliente = true;
          this.showPersonasAutorizadas = true;

          this._Register.showBtnAccesoFirmaJuridico();

          this.estAnexo = true;

          setTimeout(() => {
            this.move(5);
            this.estAnexo = true;

            this.abrirAnexo();
          }, 5);



        }

        this.carDataOne = false
      });
    }, 5000);
  }
  firstFormGroup: FormGroup;
  secondFormGroup: FormGroup;
  treeFormGroup: FormGroup;

  fourFormGroup: FormGroup;
  dataOne;
  dataTwo;
  // dataTree;


  dataFour;
  dataFinal: any = [];
  dataAccionista = [];
  dataPersonaJur = [];
  carDataOne;

  move(index: number) {
    this.myStepper.selectedIndex = index;
  }

  funciondeTiempo() {
    this.carDataOne = true;
  }


  cargarDepartamentos() {
    this._Register.getDepartamentos().subscribe(
      (resp) => {
        this.departamentos = resp;
        this.departamentoPersonaAutorizada = resp;
      },
      (error) => {
        console.log("Ha ocurrido un error!")
        console.log(error);
      }
    )
  }

  cargarProvinciasPersonaAutorizadaSelect(departamento: String) {
    this._Register.getPronvincias(departamento).subscribe(
      (resp) => {

        this.provinciasPersonaAutorizada = [{}, ...resp];
      },
      (error) => {
        console.log("Ha ocurrido un error!")
        console.log(error);
      }
    )
  }

  cargarProvincias(departamento: String) {
    this._Register.getPronvincias(departamento).subscribe(
      (resp) => {
        this.provincias = [{}, ...resp];
      },
      (error) => {
        console.log("Ha ocurrido un error!")
        console.log(error);
      }
    )
  }

  onChangeDepartamentosSelect() {

    this.cargarProvincias(this.departamento);
    this.distritos = []

  }

  onChangeDepartamentosPersonaAutorizadaSelect() {

    this.cargarProvinciasPersonaAutorizadaSelect(this.departamentoPersonaAutorizada);
    this.distritosPersonaAutorizada = []

  }

  onChangeProvinciaSelect() {

    this.cargarDistritos(this.provincia)
  }


  onChangeProvinciaPersonaAutorizadaSelect() {
    this.cargarDistritosPersonaAutorizada(this.provinciaPersonaAutorizada)
  }


  cargarDistritosPersonaAutorizada(provincia: String) {
    this._Register.getDistritos(provincia).subscribe(
      (resp) => {

        this.distritosPersonaAutorizada = [{}, ...resp];

      },
      (error) => {
        console.log("Ha ocurrido un error!")
        console.log(error);

      }
    )

  }

  cargarDistritos(provincia: String) {
    this._Register.getDistritos(provincia).subscribe(
      (resp) => {
        this.distritos = [{}, ...resp];

      },
      (error) => {
        console.log("Ha ocurrido un error!")
        console.log(error);

      }
    )

  }





  ngOnInit(): void {




    //   this.cargarDataFormOperacionesDelClienteJuridico(),

    //   this.cargarDataFormInformacionPatrimonial(),

    //   this.cargarDataTwoFormJuridico(),

    //   this.cargarDataFormVinculadosAlCliente(),

    //   this.cargarDepartamentos(),

    //   this.cargarDataFourFormJuridico()

    //TODO: Mover al final
    this.cargarDepartamentos();


    this.funciondeTiempo();

    this._Register.getOneFormJuridico().subscribe((data) => {
      this.dataOne = data.data;

      this.cargarProvincias(this.dataOne.departamento);

      this.cargarDistritos(this.dataOne.provincia);

      this.departamento = this.dataOne.departamento;


      this.provincia = this.dataOne.provincia;
      this.distrito = this.dataOne.distrito



      this.firstFormGroup = this._formBuilder.group({
        razSoc: [this.dataOne.razon_social, Validators.required], //ya
        admin: [this.dataOne.administrador, Validators.required], //ya
        parReg: [this.dataOne.partida_registral, Validators.required], //ya
        tipDoc: [this.dataOne.tipo_documento, Validators.required], //ya
        numDoc: [this.dataOne.nro_documento, Validators.required], //ya
        regPerJur: [
          this.dataOne.registro_de_personas_juridicas,
          Validators.required,
        ], //ya
        paisToCons: [this.dataOne.pais_de_constitucion, Validators.required], //ya
        dirDom: [this.dataOne.direccion, Validators.required], //ya
        depar: [this.dataOne.departamento, Validators.required], //ya
        prov: [this.dataOne.provincia, Validators.required], //ya
        distri: [this.dataOne.distrito, Validators.required], //ya
        pais: [this.dataOne.pais, Validators.required],
        codPos: [this.dataOne.codigo_postal, Validators.required],
        celu: [this.dataOne.celular, Validators.required],
        telFijo: [this.dataOne.telefono_fijo || null],
        email: [this.dataOne.correo, Validators.required], //ya
        pagWeb: [this.dataOne.pagina_web || null],
      });
      this.isLoadingDataIdentificacionDelCliente = false;


      //    this.carDataOne = false;
    });

    this._Register.getTwoFormJuridico().subscribe((data) => {
      this.dataTwo = data.data;
      this.secondFormGroup = this._formBuilder.group({
        questone: [this.dataTwo.fecha_inicio_actividades, Validators.required], //ya
        questtwo: [this.dataTwo.ciuu, Validators.required], //ya
        questtree: [
          this.dataTwo.pais_desarrollo_actividad_principal,
          Validators.required,
        ], //ya
        questfour: [
          this.dataTwo.obligado_informar_uif_peru,
          Validators.required,
        ], //ya
        questfive: [
          this.dataTwo.designo_a_su_oficial_de_cumplimiento,
          Validators.required,
        ], //ya
        questsix: [this.dataTwo.esta_vinculado_a_ind, Validators.required], //ya
        questseven: [
          this.dataTwo.representante_o_funcionario_otra_sab,
          Validators.required,
        ], //ya
        questeight: [
          this.dataTwo.inversionista_institucional,
          Validators.required,
        ], //ya
        questnine: [
          JSON.parse(this.dataTwo.tipos_de_operaciones_a_realizar),
          Validators.required,
        ], //ya

        questten: [ // TODO: COnsultar con Daniel por que viene sin ] al final   JSON.parse(this.dataTwo.modalidad_envio_ordenes)
          JSON.parse(this.dataTwo.modalidad_envio_ordenes),

          Validators.required,
        ],

        questeleven: [
          this.dataTwo.estado_cuenta_e_informacion_operaciones,
          Validators.required,
        ], //ya

        questtwelve: [
          this.dataTwo.busca_alternativas_financiamiento,
          Validators.required,
        ], //ya
      });
    });

    this.cargarDataFormOperacionesDelClienteJuridico();

    this.cargarDataFormInformacionPatrimonial();

    this.cargarDataFormVinculadosAlCliente();

    this._Register.getFourFormJuridico().subscribe((data) => {
      this.dataFour = data.data;


      if (data.data.vinculo_con_la_pj_detalle != null) {
        this.dataFinal = JSON.parse(data.data.vinculo_con_la_pj_detalle);
      }




      this.cargarProvinciasPersonaAutorizadaSelect(this.dataFinal.departamento);


      this.cargarDistritosPersonaAutorizada(this.dataFinal.provincia);


      this.departamentoPersonaAutorizada = this.dataFinal.departamento;
      this.provinciaPersonaAutorizada = this.dataFinal.provincia;
      this.distritoPersonaAutorizada = this.dataFinal.distrito;






      this.fourFormGroup = this._formBuilder.group({
        questone: [this.dataFour.vinculo_con_la_pj, Validators.required], //ya
        questtwo: [this.dataFinal.nombre, Validators.required], //ya
        questtree: [this.dataFinal.apellidos, Validators.required], //ya
        questfour: [this.dataFinal.fecha_nacimiento, Validators.required], //ya
        questfive: [this.dataFinal.tipo_documento, Validators.required], //ya
        questsix: [this.dataFinal.nro_documento, Validators.required], //ya
        questseven: [this.dataFinal.nacionalidad, Validators.required], //ya
        questeight: [this.dataFinal.pais_nacimiento, Validators.required], //ya
        questnine: [this.dataFinal.direccion, Validators.required], //ya
        questten: [this.dataFinal.estado_civil, Validators.required], //ya
        questeleven: [this.dataFinal.departamento, Validators.required], //ya
        questtwelve: [this.dataFinal.provincia, Validators.required], //ya
        questthirteen: [this.dataFinal.distrito, Validators.required], //ya
        questfourteen: [this.dataFinal.pais, Validators.required], //ya
        questfivteen: [this.dataFinal.codigo_postal, Validators.required], //ya
        questsixteen: [this.dataFinal.celular, Validators.required], //ya
        questseventeen: [this.dataFinal.telefono_fijo, Validators.required], //ya
        questeighteen: [this.dataFinal.correo, Validators.required], //ya
        questtwuelve: [this.dataFinal.fecha_poder, Validators.required], //ya
        questtwuelveone: [
          this.dataFinal.partida_registral,
          Validators.required,
        ], //ya
        questtwuelvetwo: [
          this.dataFinal.expuesto_politicamente_o_pertenece_pep,
          Validators.required,
        ], //ya
        questtwuelvetree: [
          this.dataFinal.registro_personas_juridicas,
          Validators.required,
        ], //ya
        questtwuelvefour: [this.dataFinal.p_o_pep_nombres, Validators.required], //ya
        questtwuelvefive: [
          this.dataFinal.p_o_pep_apellidos,
          Validators.required,
        ], //ya
        questtwuelvesix: [
          this.dataFinal.p_o_pep_nombre_institucion,
          Validators.required,
        ], //ya
        questtwuelveseven: [this.dataFinal.p_o_pep_cargo, Validators.required], //ya
      });


      this.isLoadinData = false;
    });

  }

  estAnexo = false;

  onClick() {


    const token = localStorage.getItem("tokenRegister")
    this._router.navigate([`/unete/firma-digital/token?${token}`]);


    //this.mostrarFirmas = !this.mostrarFirmas;
  }

  showExposedPersonOptions(event) {

    if (event == "Si") {
      this.boxingExposedPersonOptions = true;


    } else {
      this.boxingExposedPersonOptions = false;

    }
  }

  showIsProxy(event) {
    if (event == "Representante legal/apoderado") {
      this.boxingIsProxy = true;


    } else {
      this.boxingIsProxy = false;

    }
  }
  abrirAnexo() {
    this.modalService
      .open(AnexoJuridicoComponent, { windowClass: "dark-modal", size: "lg" })
      .result.then(
        (result) => {
          // console.log(result);
        },
        (reason) => {
          // console.log(reason);
        }
      );
  }

  paqueteSelected = "";
  boxing = false;

  apaOption(event) {
    if (event == "Si") {
      this.boxing = true;
    } else {
      this.boxing = false;
    }
  }

  variable1;

  apa2 = false;
  apa3 = false;
  apa4 = false;
  apa5 = false;

  Indice = 1;

  onStepChange(event: any): void {
    this.Indice = event.selectedIndex + 1;
  }

  tipOpeList: string[] = [
    "Renta variable (acciones y/o etfs)",
    "Renta fija (papeles comerciales y/o bonos)",
    "Facturas negociables",
    "Operaciones de reporte",
    "Derivados",
    "Operaciones de cambio de monedas",
  ];

  tipTwoList: string[] = [
    "Telefónica (con grabación de llamadas)",
    "Correo Electrónico",
    "Acceso Web",
    "Escrito",

  ];

  tipFourList: string[] = [
    "Ingresos percibidos",
    "Ahorros/inversione",
    "Utilidades/dividendos",
    "Arrendamientos",
    "Fondos previsionales",
    "Herencia",
    "Préstamos",
    "Otros",
  ];

  variable3;

  openAccionistas(content) {
    this.limpiarAccionista();
    this.modalService
      .open(content, { size: "lg", backdrop: "static" })
      .result.then(
        (result) => {
        },
        (reason) => {
          //  console.log("Err!", reason);
        }
      );
  }

  openJuridico(content) {
    this.limpiar();
    this.modalService
      .open(content, { size: "md", backdrop: "static" })
      .result.then(
        (result) => {
        },
        (reason) => {
          console.log("Err!", reason);
        }
      );
  }
  daJuri;
  iJuri;
  openeditJuridico(content, row, index) {
    ;
    this.DatosUpdate = JSON.stringify(row);
    this.daJuri = JSON.parse(JSON.stringify(row));
    this.iJuri = index;

    this.modalService
      .open(content, { size: "md", backdrop: "static" })
      .result.then(
        (result) => {
          // console.log(result);
        },
        (reason) => {
          // console.log(reason);
        }
      );
  }

  DatosUpdate2;
  datAcc;
  iAcc;
  openeditAccionista(content, row, index) {
    this.DatosUpdate2 = JSON.stringify(row);
    this.datAcc = JSON.parse(JSON.stringify(row));
    this.iAcc = index;
    this.modalService
      .open(content, { size: "md", backdrop: "static" })
      .result.then(
        (result) => {
          console.log(result);
        },
        (reason) => {
          console.log(reason);
        }
      );
  }

  saveEditAcc() {



    // if (this.DatosUpdate2 === JSON.stringify(this.datAcc)) {
    this.dataAccionista.push(this.datAcc);
    this.dataAccionista.splice(this.iAcc, 1);
    this.modalService.dismissAll();
  }

  DatosUpdate;
  saveEditJuridico() {
    if (this.DatosUpdate === JSON.stringify(this.daJuri)) {
    }
    this.dataPersonaJur.push(this.daJuri);
    this.dataPersonaJur.splice(this.iJuri, 1);
    this.modalService.dismissAll();
  }

  dateJuridico;
  dato1;
  dato2;
  dato3;
  dato4;

  datoAcc1;
  datoAcc2;
  datoAcc3;
  datoAcc4;
  datoAcc5;
  datoAcc6;
  datoAcc7;
  datoAcc8;
  datoAcc9;

  limpiarAccionista() {
    this.datoAcc1 = "";
    this.datoAcc2 = "";
    this.datoAcc3 = "";
    this.datoAcc4 = "";
    this.datoAcc5 = "";
    this.datoAcc6 = "";
    this.datoAcc7 = "";
    this.datoAcc8 = "";
    this.datoAcc9 = "";
  }
  limpiar() {
    this.dato1 = "";
    this.dato2 = "";
    this.dato3 = "";
    this.dato4 = "";
  }

  dateAccionista;

  validaciónAccionista() {
    if (this.datoAcc1 == "") {
      Swal.fire("Ingrese un nombre o razón social", "", "warning");
      return;
    }
    if (this.datoAcc2 == "") {
      Swal.fire("Ingrese apellidos", "", "warning");
      return;
    }
    if (this.datoAcc3 == "") {
      Swal.fire("Seleccione tipo de documento", "", "warning");
      return;
    }
    if (this.datoAcc4 == "") {
      Swal.fire("Ingreso N° de documento", "", "warning");
      return;
    }
    if (this.datoAcc5 == "") {
      Swal.fire("Seleccione nacionalidad", "", "warning");
      return;
    }
    if (this.datoAcc6 == "") {
      Swal.fire("Seleccione su país de residencia", "", "warning");
      return;
    }
    if (this.datoAcc7 == "") {
      Swal.fire("Seleccione fecha de nacimiento", "", "warning");
      return;
    }
    if (this.datoAcc8 == "") {
      Swal.fire(
        "Seleccione si es una persona expuesta políticamente o tiene vinculación con un PEP",
        "",
        "warning"
      );
      return;
    }
    if (this.datoAcc9 == "") {
      Swal.fire("Ingrese su participación", "", "warning");
      return;
    } else {
      return true;
    }
  }

  guardarAccionista() {
    var validar = this.validaciónAccionista();
    if (validar) {
      this.dateAccionista = {
        nombre_o_razon_social: this.datoAcc1,
        apellidos: this.datoAcc2,
        tipo_documento: this.datoAcc3,
        nro_documento: this.datoAcc4,
        nacionalidad: this.datoAcc5,
        pais_residencia: this.datoAcc6,
        fecha_nacimiento: this.datoAcc7,
        expuesto_politicamente_o_pertenece_pep: this.datoAcc8,
        participacion: this.datoAcc9,
      };

      this.dataAccionista.push(this.dateAccionista);
      this.limpiarAccionista();
      this.modalService.dismissAll();

    } else {
      return;
    }
  }

  validacionPersonaJuridica() {
    if (this.dato1 == "") {
      Swal.fire("Ingrese una razón social", "", "warning");
      return;
    }
    if (this.dato2 == "") {
      Swal.fire("Seleccione un tipo de documento", "", "warning");
      return;
    }
    if (this.dato3 == "") {
      Swal.fire("Ingrese un numero de documento", "", "warning");
      return;
    }
    if (this.dato4 == "") {
      Swal.fire("Seleccione su tipo de vinculación", "", "warning");
      return;
    } else {
      return true;
    }
  }
  guardarPersonJuridica() {
    var validar = this.validacionPersonaJuridica();
    if (validar) {
      this.dateJuridico = {
        razon_social: this.dato1,
        tipo_documento: this.dato2,
        nro_documento: this.dato3,
        tipo_vinculacion: this.dato4,
      };
      this.dataPersonaJur.push(this.dateJuridico);
      this.limpiar();
      this.modalService.dismissAll();

    } else {
      return;
    }
  }

  deletAccionistas(index) {
    this.dataAccionista.splice(index, 1);

  }

  deletJuridico(index) {
    this.dataPersonaJur.splice(index, 1);

  }


  completarRegistro(expuestoPoliticamente) {
    if (
      this.fourFormGroup.get("questone").value == "" ||
      this.fourFormGroup.get("questone").value == undefined ||
      this.fourFormGroup.get("questone").value == null
    ) {
      Swal.fire("Seleccione que vínculo tienes con la PJ", "", "warning");
      return;
    }

    if (
      this.fourFormGroup.get("questtwo").value == "" ||
      this.fourFormGroup.get("questtwo").value == undefined ||
      this.fourFormGroup.get("questtwo").value == null
    ) {
      Swal.fire("Ingrese su nombre", "", "warning");
      return;
    }

    if (
      this.fourFormGroup.get("questtree").value == "" ||
      this.fourFormGroup.get("questtree").value == undefined ||
      this.fourFormGroup.get("questtree").value == null
    ) {
      Swal.fire("Ingrese su apellido", "", "warning");
      return;
    }

    if (
      this.fourFormGroup.get("questfour").value == "" ||
      this.fourFormGroup.get("questfour").value == undefined ||
      this.fourFormGroup.get("questfour").value == null
    ) {
      Swal.fire("Ingrese su fecha de nacimiento", "", "warning");
      return;
    }

    if (
      this.fourFormGroup.get("questfive").value == "" ||
      this.fourFormGroup.get("questfive").value == undefined ||
      this.fourFormGroup.get("questfive").value == null
    ) {
      Swal.fire("Seleccione su tipo de documento", "", "warning");
      return;
    }

    if (
      this.fourFormGroup.get("questsix").value == "" ||
      this.fourFormGroup.get("questsix").value == undefined ||
      this.fourFormGroup.get("questsix").value == null
    ) {
      Swal.fire("Ingrese su número de documento", "", "warning");
      return;
    }

    if (
      this.fourFormGroup.get("questseven").value == "" ||
      this.fourFormGroup.get("questseven").value == undefined ||
      this.fourFormGroup.get("questseven").value == null
    ) {
      Swal.fire("Ingrese su nacionalidad ", "", "warning");
      return;
    }

    if (
      this.fourFormGroup.get("questeight").value == "" ||
      this.fourFormGroup.get("questeight").value == undefined ||
      this.fourFormGroup.get("questeight").value == null
    ) {
      Swal.fire("Ingrese su país de nacimiento", "", "warning");
      return;
    }

    if (
      this.fourFormGroup.get("questnine").value == "" ||
      this.fourFormGroup.get("questnine").value == undefined ||
      this.fourFormGroup.get("questnine").value == null
    ) {
      Swal.fire("Ingrese su dirección de domicilio  ", "", "warning");
      return;
    }

    // if (
    //   this.fourFormGroup.get("questten").value == "" ||
    //   this.fourFormGroup.get("questten").value == undefined ||
    //   this.fourFormGroup.get("questten").value == null
    // ) {
    //   Swal.fire("Seleccione su estado civil", "", "warning");
    //   return;
    // }

    if (
      this.fourFormGroup.get("questeleven").value == "" ||
      this.fourFormGroup.get("questeleven").value == undefined ||
      this.fourFormGroup.get("questeleven").value == null
    ) {
      Swal.fire("Seleccione su departamento", "", "warning");
      return;
    }

    if (
      this.fourFormGroup.get("questtwelve").value == "" ||
      this.fourFormGroup.get("questtwelve").value == undefined ||
      this.fourFormGroup.get("questtwelve").value == null
    ) {
      Swal.fire("Ingrese su provincia", "", "warning");
      return;
    }

    if (
      this.fourFormGroup.get("questthirteen").value == "" ||
      this.fourFormGroup.get("questthirteen").value == undefined ||
      this.fourFormGroup.get("questthirteen").value == null
    ) {
      Swal.fire("Seleccione su distrito", "", "warning");
      return;
    }

    if (
      this.fourFormGroup.get("questfourteen").value == "" ||
      this.fourFormGroup.get("questfourteen").value == undefined ||
      this.fourFormGroup.get("questfourteen").value == null
    ) {
      Swal.fire("Ingrese su país", "", "warning");
      return;
    }

    if (
      this.fourFormGroup.get("questfivteen").value == "" ||
      this.fourFormGroup.get("questfivteen").value == undefined ||
      this.fourFormGroup.get("questfivteen").value == null
    ) {
      Swal.fire("Ingrese su código postal", "", "warning");
      return;
    }

    if (
      this.fourFormGroup.get("questsixteen").value == "" ||
      this.fourFormGroup.get("questsixteen").value == undefined ||
      this.fourFormGroup.get("questsixteen").value == null
    ) {
      Swal.fire("Seleccione su número de celular", "", "warning");
      return;
    }
    if (
      this.fourFormGroup.get("questseventeen").value == "" ||
      this.fourFormGroup.get("questseventeen").value == undefined ||
      this.fourFormGroup.get("questseventeen").value == null
    ) {
      Swal.fire("Ingrese su telefono fijo", "", "warning");
      return;
    }

    if (
      this.fourFormGroup.get("questeighteen").value == "" ||
      this.fourFormGroup.get("questeighteen").value == undefined ||
      this.fourFormGroup.get("questeighteen").value == null
    ) {
      Swal.fire("Seleccione su correo", "", "warning");
      return;
    }

    if (
      (this.fourFormGroup.get("questtwuelve").value == "" ||
        this.fourFormGroup.get("questtwuelve").value == undefined ||
        this.fourFormGroup.get("questtwuelve").value == null) &&
      this.fourFormGroup.get("questone").value == 'Representante legal/apoderado'
    ) {
      Swal.fire("Seleccione su fecha del poder", "", "warning");
      return;
    }

    if (
      (this.fourFormGroup.get("questtwuelveone").value == "" ||
        this.fourFormGroup.get("questtwuelveone").value == undefined ||
        this.fourFormGroup.get("questtwuelveone").value == null) &&
      this.fourFormGroup.get("questone").value == 'Representante legal/apoderado'

    ) {
      Swal.fire("Seleccione el N° de Partida Registral", "", "warning");
      return;
    }

    if (
      this.fourFormGroup.get("questtwuelvetwo").value == "" ||
      this.fourFormGroup.get("questtwuelvetwo").value == undefined ||
      this.fourFormGroup.get("questtwuelvetwo").value == null
    ) {
      Swal.fire(
        "Seleccione si es una persona expuesta políticamente o tiene vinculación con un PEP",
        "",
        "warning"
      );
      return;
    }

    if (
      this.fourFormGroup.get("questtwuelvetree").value == "" ||
      this.fourFormGroup.get("questtwuelvetree").value == undefined ||
      this.fourFormGroup.get("questtwuelvetree").value == null
    ) {
      Swal.fire(
        "Seleccione su registro de personas jurídicas de",
        "",
        "warning"
      );
      return;
    }



    if (
      (this.fourFormGroup.get("questtwuelvefour").value == "" ||
        this.fourFormGroup.get("questtwuelvefour").value == undefined ||
        this.fourFormGroup.get("questtwuelvefour").value == null) && expuestoPoliticamente == 'Si'
    ) {
      Swal.fire("Ingrese su nombre", "", "warning");
      return;
    }

    if (
      (this.fourFormGroup.get("questtwuelvefive").value == "" ||
        this.fourFormGroup.get("questtwuelvefive").value == undefined ||
        this.fourFormGroup.get("questtwuelvefive").value == null) && expuestoPoliticamente == 'Si'
    ) {
      Swal.fire("Ingrese su apellido", "", "warning");
      return;
    }

    if (
      (this.fourFormGroup.get("questtwuelvesix").value == "" ||
        this.fourFormGroup.get("questtwuelvesix").value == undefined ||
        this.fourFormGroup.get("questtwuelvesix").value == null) && expuestoPoliticamente == 'Si'
    ) {
      Swal.fire("Ingrese el nombre de su institución", "", "warning");
      return;
    }

    if (
      (this.fourFormGroup.get("questtwuelveseven").value == "" ||
        this.fourFormGroup.get("questtwuelveseven").value == undefined ||
        this.fourFormGroup.get("questtwuelveseven").value == null) && expuestoPoliticamente == 'Si'
    ) {
      Swal.fire("Seleccione su cargo", "", "warning");
      return;
    } else {
      return true;
    }
  }

  eventoSiguienteTree() {
    if (
      this.treeFormGroup.get("question_tipos_operacion_realizar").value == "" ||
      this.treeFormGroup.get("question_tipos_operacion_realizar").value == undefined ||
      this.treeFormGroup.get("question_tipos_operacion_realizar").value == null
    ) {
      Swal.fire("Seleccione un tipo de operación a realizar", "", "warning");
      return;
    }

    if (
      this.treeFormGroup.get("questtree").value == "" ||
      this.treeFormGroup.get("questtree").value == undefined ||
      this.treeFormGroup.get("questtree").value == null
    ) {
      Swal.fire(
        "Ingrese su información financiera del último ejercicio - fecha",
        "",
        "warning"
      );
      return;
    }

    if (
      this.treeFormGroup.get("questfour").value == "" ||
      this.treeFormGroup.get("questfour").value == undefined ||
      this.treeFormGroup.get("questfour").value == null
    ) {
      Swal.fire("Seleccione si procedencia de fondos", "", "warning");
      return;
    }

    if (
      this.treeFormGroup.get("questfive").value == "" ||
      this.treeFormGroup.get("questfive").value == undefined ||
      this.treeFormGroup.get("questfive").value == null
    ) {
      Swal.fire("Seleccione  una opción a la pregunta ", "", "warning");
      return;
    } else {
      return true;
    }
  }

  eventoSiguienteTwo() {


    if (
      this.secondFormGroup.get("questone").value == "" ||
      this.secondFormGroup.get("questone").value == undefined ||
      this.secondFormGroup.get("questone").value == null
    ) {
      Swal.fire("Seleccione su fecha de inicio de actividades", "", "warning");
      return;
    }

    if (
      this.secondFormGroup.get("questtwo").value == "" ||
      this.secondFormGroup.get("questtwo").value == undefined ||
      this.secondFormGroup.get("questtwo").value == null
    ) {
      Swal.fire("Seleccione su CIUU", "", "warning");
      return;
    }

    if (
      this.secondFormGroup.get("questtree").value == "" ||
      this.secondFormGroup.get("questtree").value == undefined ||
      this.secondFormGroup.get("questtree").value == null
    ) {
      Swal.fire(
        "Ingrese su país de desarrollo de actividad principal",
        "",
        "warning"
      );
      return;
    }

    if (
      this.secondFormGroup.get("questfour").value == "" ||
      this.secondFormGroup.get("questfour").value == undefined ||
      this.secondFormGroup.get("questfour").value == null
    ) {
      Swal.fire(
        "Seleccione si es sujeto obligado a informar a la UIF-PERÚ",
        "",
        "warning"
      );
      return;
    }

    if (
      this.secondFormGroup.get("questfive").value == "" ||
      this.secondFormGroup.get("questfive").value == undefined ||
      this.secondFormGroup.get("questfive").value == null
    ) {
      Swal.fire(
        "Seleccione si designó a su oficial de cumplimiento ",
        "",
        "warning"
      );
      return;
    }

    if (
      this.secondFormGroup.get("questsix").value == "" ||
      this.secondFormGroup.get("questsix").value == undefined ||
      this.secondFormGroup.get("questsix").value == null
    ) {
      Swal.fire("Seleccione una opcion si está vinculado a IND", "", "warning");
      return;
    }

    if (
      this.secondFormGroup.get("questseven").value == "" ||
      this.secondFormGroup.get("questseven").value == undefined ||
      this.secondFormGroup.get("questseven").value == null
    ) {
      Swal.fire(
        "Seleccione una opcion si es representante o funcionario de otra SAB",
        "",
        "warning"
      );
      return;
    }

    if (
      this.secondFormGroup.get("questeight").value == "" ||
      this.secondFormGroup.get("questeight").value == undefined ||
      this.secondFormGroup.get("questeight").value == null
    ) {
      Swal.fire(
        "Seleccione una opcion si es un inversionista institucional",
        "",
        "warning"
      );
      return;
    }

    if (
      this.secondFormGroup.get("questnine").value == "" ||
      this.secondFormGroup.get("questnine").value == undefined ||
      this.secondFormGroup.get("questnine").value == null
    ) {
      Swal.fire(
        "Seleccione sus tipos de operaciones a realizar",
        "",
        "warning"
      );
      return;
    }

    if (
      this.secondFormGroup.get("questten").value == "" ||
      this.secondFormGroup.get("questten").value == undefined ||
      this.secondFormGroup.get("questten").value == null
    ) {
      Swal.fire("Seleccione su modalidad de envío de órdenes", "", "warning");
      return;
    }

    if (
      this.secondFormGroup.get("questeleven").value == "" ||
      this.secondFormGroup.get("questeleven").value == undefined ||
      this.secondFormGroup.get("questeleven").value == null
    ) {
      Swal.fire(
        "Seleccione si tiene acceso a estado de cuenta e información de operaciones",
        "",
        "warning"
      );
      return;
    }

    if (
      this.secondFormGroup.get("questtwelve").value == "" ||
      this.secondFormGroup.get("questtwelve").value == undefined ||
      this.secondFormGroup.get("questtwelve").value == null
    ) {
      Swal.fire(
        "Seleccione si busca alternativas de financiamiento",
        "",
        "warning"
      );
      return;
    } else {
      return true;
    }
  }

  eventSiguiente() {
    if (
      this.firstFormGroup.get("razSoc").value == "" ||
      this.firstFormGroup.get("razSoc").value == undefined ||
      this.firstFormGroup.get("razSoc").value == null
    ) {
      Swal.fire("Debe ingresar una razón social", "", "warning");
      return;
    }

    if (
      this.firstFormGroup.get("admin").value == "" ||
      this.firstFormGroup.get("admin").value == undefined ||
      this.firstFormGroup.get("admin").value == null ||
      this.firstFormGroup.get("admin").value.length <= 3
    ) {
      Swal.fire("Debe ingresar un administrador", "", "warning");
      return;
    }
    if (
      this.firstFormGroup.get("tipDoc").value == "" ||
      this.firstFormGroup.get("tipDoc").value == undefined ||
      this.firstFormGroup.get("tipDoc").value == null
    ) {
      Swal.fire("Debe seleccionar un tipo de documento ", "", "warning");
      return;
    }

    if (
      this.firstFormGroup.get("numDoc").value == "" ||
      this.firstFormGroup.get("numDoc").value == undefined ||
      this.firstFormGroup.get("numDoc").value == null
    ) {
      Swal.fire("Debe ingresar un número de documento ", "", "warning");
      return;
    }

    if (
      this.firstFormGroup.get("parReg").value == "" ||
      this.firstFormGroup.get("parReg").value == undefined ||
      this.firstFormGroup.get("parReg").value == null
    ) {
      Swal.fire("Debe ingresar una partida registral", "", "warning");
      return;
    }

    if (
      this.firstFormGroup.get("regPerJur").value == "" ||
      this.firstFormGroup.get("regPerJur").value == undefined ||
      this.firstFormGroup.get("regPerJur").value == null
    ) {
      Swal.fire(
        "Debe seleccionar el tipo de registro de persona jurídica",
        "",
        "warning"
      );
      return;
    }

    if (
      this.firstFormGroup.get("paisToCons").value == "" ||
      this.firstFormGroup.get("paisToCons").value == undefined ||
      this.firstFormGroup.get("paisToCons").value == null
    ) {
      Swal.fire("Debe seleccionar su pais de constitución", "", "warning");
      return;
    }

    if (
      this.firstFormGroup.get("dirDom").value == "" ||
      this.firstFormGroup.get("dirDom").value == undefined ||
      this.firstFormGroup.get("dirDom").value == null
    ) {
      Swal.fire("Debe ingresar una dirección de domicilio", "", "warning");
      return;
    }
    /*     if (
      this.firstFormGroup.get("estCiv").value == "" ||
      this.firstFormGroup.get("estCiv").value == undefined ||
      this.firstFormGroup.get("estCiv").value == null
    ) {
      Swal.fire("Debe ingresar su estado civil", "", "warning");
      return;
    } */

    if (
      this.firstFormGroup.get("depar").value == "" ||
      this.firstFormGroup.get("depar").value == undefined ||
      this.firstFormGroup.get("depar").value == null
    ) {
      Swal.fire("Debe ingresar su departamento", "", "warning");
      return;
    }

    if (
      this.firstFormGroup.get("prov").value == "" ||
      this.firstFormGroup.get("prov").value == undefined ||
      this.firstFormGroup.get("prov").value == null
    ) {
      Swal.fire("Debe ingresar su provincia", "", "warning");
      return;
    }

    if (
      this.firstFormGroup.get("distri").value == "" ||
      this.firstFormGroup.get("distri").value == undefined ||
      this.firstFormGroup.get("distri").value == null
    ) {
      Swal.fire("Debe ingresar su distrito", "", "warning");
      return;
    }

    if (
      this.firstFormGroup.get("pais").value == "" ||
      this.firstFormGroup.get("pais").value == undefined ||
      this.firstFormGroup.get("pais").value == null
    ) {
      Swal.fire("Debe ingresar su país", "", "warning");
      return;
    }

    if (
      this.firstFormGroup.get("codPos").value == "" ||
      this.firstFormGroup.get("codPos").value == undefined ||
      this.firstFormGroup.get("codPos").value == null
    ) {
      Swal.fire("Debe ingresar su código postal", "", "warning");
      return;
    }

    if (
      this.firstFormGroup.get("celu").value == "" ||
      this.firstFormGroup.get("celu").value == undefined ||
      this.firstFormGroup.get("celu").value == null ||
      this.firstFormGroup.get("celu").value.length <= 8
    ) {
      Swal.fire("Debe ingresar un número de celular", "", "warning");
      return;
    }
    /*   if (
      this.firstFormGroup.get("telFijo").value == "" ||
      this.firstFormGroup.get("telFijo").value == undefined ||
      this.firstFormGroup.get("telFijo").value == null
    ) {
      Swal.fire("Debe ingresar un teléfono fijo", "", "warning");
      return;
    } */

    if (
      this.firstFormGroup.get("email").value == "" ||
      this.firstFormGroup.get("email").value == undefined ||
      this.firstFormGroup.get("email").value == null ||
      this.firstFormGroup.get("email").invalid
    ) {
      Swal.fire("Correo inválido", "", "warning");
      return;
    } else {
      return true;
    }
    /*  if (
      this.firstFormGroup.get("pagWeb").value == "" ||
      this.firstFormGroup.get("pagWeb").value == undefined ||
      this.firstFormGroup.get("pagWeb").value == null
    ) {
      Swal.fire("Debe ingresar un teléfono fijo", "", "warning");
      return;
    }
 */
  }
  dataCorrecto;
  savePersonasAutorizadas() {
    this.dataCorrecto = {
      apellidos: this.fourFormGroup.get("questtree").value,
      celular: this.fourFormGroup.get("questsixteen").value,
      codigo_postal: this.fourFormGroup.get("questfivteen").value,
      correo: this.fourFormGroup.get("questeighteen").value,
      departamento: this.fourFormGroup.get("questeleven").value,
      direccion: this.fourFormGroup.get("questnine").value,
      distrito: this.fourFormGroup.get("questthirteen").value,
      // estado_civil: this.fourFormGroup.get("questten").value,
      estado_civil: null,
      expuesto_politicamente_o_pertenece_pep:
        this.fourFormGroup.get("questtwuelvetwo").value,
      fecha_nacimiento: this.fourFormGroup.get("questfour").value,
      fecha_poder: this.fourFormGroup.get("questtwuelve").value,
      nacionalidad: this.fourFormGroup.get("questseven").value,
      nombre: this.fourFormGroup.get("questtwo").value,
      nro_documento: this.fourFormGroup.get("questsix").value,
      p_o_pep_apellidos: this.fourFormGroup.get("questtwuelvefive").value,
      p_o_pep_cargo: this.fourFormGroup.get("questtwuelveseven").value,
      p_o_pep_nombre_institucion:
        this.fourFormGroup.get("questtwuelvesix").value,
      p_o_pep_nombres: this.fourFormGroup.get("questtwuelvefour").value,
      pais: this.fourFormGroup.get("questfourteen").value,
      pais_nacimiento: this.fourFormGroup.get("questeight").value,
      partida_registral: this.fourFormGroup.get("questtwuelveone").value,
      provincia: this.fourFormGroup.get("questtwelve").value,
      registro_personas_juridicas:
        this.fourFormGroup.get("questtwuelvetree").value,
      telefono_fijo: this.fourFormGroup.get("questseventeen").value,
      tipo_documento: this.fourFormGroup.get("questfive").value,
    };



    if (this.dataCorrecto.expuesto_politicamente_o_pertenece_pep == 'No') {

      this.dataCorrecto.p_o_pep_nombres = null;
      this.dataCorrecto.p_o_pep_apellidos = null;
      this.dataCorrecto.p_o_pep_nombre_institucion = null;
      this.dataCorrecto.p_o_pep_cargo = null;

    }


    var validar = this.completarRegistro(this.dataCorrecto.expuesto_politicamente_o_pertenece_pep);
    if (validar) {
      let data = {
        vinculo_con_la_pj: this.fourFormGroup.get("questone").value,
        vinculo_con_la_pj_detalle: JSON.stringify(this.dataCorrecto),
      };


      this._Register.editFourFormJuridico(data).subscribe(
        (response: any) => {
          this.estAnexo = true;

          Swal.fire(
            "Se actualizo el formulario información patrimonial y origen de fondos",
            "",
            "success"
          );


          setTimeout(() => {
            this.myStepper.next();
          }, 10);
        },
        (error) => {
          Swal.fire(error.error.statusMessage, "", "warning");
          return;
        }
      );
    } else {
      return;
    }
  }

  isValidInformacionPatrimonial(): Boolean {

    if (
      this.informacionPatrimonialFormGroup.get(this.informacionPatrimonialQuestions.ingreso_promedio_mensual).value == "" ||
      this.informacionPatrimonialFormGroup.get(this.informacionPatrimonialQuestions.ingreso_promedio_mensual).value == undefined ||
      this.informacionPatrimonialFormGroup.get(this.informacionPatrimonialQuestions.ingreso_promedio_mensual).value == null ||
      this.informacionPatrimonialFormGroup.get(this.informacionPatrimonialQuestions.ingreso_promedio_mensual).value == 0
    ) {
      Swal.fire("Seleccione un ingreso promedio mensual", "", "warning");
      return false;
    }


    if (
      this.informacionPatrimonialFormGroup.get(this.informacionPatrimonialQuestions.inf_financiera_ultimo_ejercicio).value == "" ||
      this.informacionPatrimonialFormGroup.get(this.informacionPatrimonialQuestions.inf_financiera_ultimo_ejercicio).value == undefined ||
      this.informacionPatrimonialFormGroup.get(this.informacionPatrimonialQuestions.inf_financiera_ultimo_ejercicio).value == null
    ) {
      Swal.fire("Seleccione información financiera del último ejercicio", "", "warning");
      return false;
    }


    if (
      this.informacionPatrimonialFormGroup.get(this.informacionPatrimonialQuestions.procedencia_fondos).value == "" ||
      this.informacionPatrimonialFormGroup.get(this.informacionPatrimonialQuestions.procedencia_fondos).value == undefined ||
      this.informacionPatrimonialFormGroup.get(this.informacionPatrimonialQuestions.procedencia_fondos).value == null ||
      this.informacionPatrimonialFormGroup.get(this.informacionPatrimonialQuestions.procedencia_fondos).value.length == 0
    ) {
      Swal.fire("Seleccione una procedencia de fondos", "", "warning");
      return false;
    }



    if (
      this.informacionPatrimonialFormGroup.get(this.informacionPatrimonialQuestions.usted_o_accionistas_investigado_delito).value == "" ||
      this.informacionPatrimonialFormGroup.get(this.informacionPatrimonialQuestions.usted_o_accionistas_investigado_delito).value == undefined ||
      this.informacionPatrimonialFormGroup.get(this.informacionPatrimonialQuestions.usted_o_accionistas_investigado_delito).value == null
    ) {
      Swal.fire("Seleccione si usted o algunos de sus accionista ha sido investigado o procesado.", "", "warning");
      return false;
    }


    return true;
  }



  isValidFormOperacionesDelCliente() {

    if (
      this.operacionesDelClienteFormGroup.get(this.operacionesDelClienteJuridicoQuestions.tipos_de_operaciones_a_realizar).value == "" ||
      this.operacionesDelClienteFormGroup.get(this.operacionesDelClienteJuridicoQuestions.tipos_de_operaciones_a_realizar).value == undefined ||
      this.operacionesDelClienteFormGroup.get(this.operacionesDelClienteJuridicoQuestions.tipos_de_operaciones_a_realizar).value == null
    ) {
      Swal.fire("Seleccione un tipo de operación a realizar", "", "warning");
      return;
    }


    if (
      this.operacionesDelClienteFormGroup.get(this.operacionesDelClienteJuridicoQuestions.busca_alternativas_financiamiento).value == "" ||
      this.operacionesDelClienteFormGroup.get(this.operacionesDelClienteJuridicoQuestions.busca_alternativas_financiamiento).value == undefined ||
      this.operacionesDelClienteFormGroup.get(this.operacionesDelClienteJuridicoQuestions.busca_alternativas_financiamiento).value == null
    ) {
      Swal.fire("Seleccione una alternativa de financiamiento", "", "warning");
      return;
    }


    if (
      this.operacionesDelClienteFormGroup.get(this.operacionesDelClienteJuridicoQuestions.modalidad_envio_ordenes).value == "" ||
      this.operacionesDelClienteFormGroup.get(this.operacionesDelClienteJuridicoQuestions.modalidad_envio_ordenes).value == undefined ||
      this.operacionesDelClienteFormGroup.get(this.operacionesDelClienteJuridicoQuestions.modalidad_envio_ordenes).value == null
    ) {
      Swal.fire("Seleccione una modalidad de envío de ordenes", "", "warning");
      return;
    }


    if (
      this.operacionesDelClienteFormGroup.get(this.operacionesDelClienteJuridicoQuestions.estado_cuenta_e_informacion_operaciones).value == "" ||
      this.operacionesDelClienteFormGroup.get(this.operacionesDelClienteJuridicoQuestions.estado_cuenta_e_informacion_operaciones).value == undefined ||
      this.operacionesDelClienteFormGroup.get(this.operacionesDelClienteJuridicoQuestions.estado_cuenta_e_informacion_operaciones).value == null
    ) {
      Swal.fire("Seleccione un acceso a estado de cuenta e información de operaciones", "", "warning");
      return;
    }

    return true;

  }


  saveInformacionPatrimonial() {


    if (this.isValidInformacionPatrimonial()) {

      const informacionPatrimonialToUpdate: InformacionPatrimonialJuridicoData = {

        ingreso_promedio_mensual:
          this.informacionPatrimonialFormGroup.get(this.informacionPatrimonialQuestions.ingreso_promedio_mensual).value,

        inf_financiera_ultimo_ejercicio:
          this.informacionPatrimonialFormGroup.get(this.informacionPatrimonialQuestions.inf_financiera_ultimo_ejercicio).value,

        procedencia_fondos:
          JSON.stringify(this.informacionPatrimonialFormGroup.get(this.informacionPatrimonialQuestions.procedencia_fondos).value),

        usted_o_accionistas_investigado_delito:
          this.informacionPatrimonialFormGroup.get(this.informacionPatrimonialQuestions.usted_o_accionistas_investigado_delito).value,

      }


      this._Register.updateInformacionPatrimonialuridico(informacionPatrimonialToUpdate).subscribe(
        (informacionPatrimonialData) => {

          this.showStepVinculadosAlCliente = true;

          Swal.fire(
            "Se actualizó el formulario información patrimonial y origen de fondos",
            "",
            "success"
          );

          setTimeout(() => {
            this.myStepper.next();
          }, 10);
        },
        (error) => {
          console.log("Ha ocurrido un error!");

          console.log(error);

          //TODO: Consultar con daniel si estan las validadciones del backend porque esta permitiendo enviar objetos vacios.
          Swal.fire("Ha ocurrido un error al intentar actualizar la información patrimonial y origen de fondos", "", "warning");

        }
      )

    }



  }

  saveOperacionesDelCliente() {

    if (this.isValidFormOperacionesDelCliente()) {

      const operacionesDelClienteToUpdate: OperacionesDelClienteJuridicoData = {

        tipos_de_operaciones_a_realizar:
          JSON.stringify(this.operacionesDelClienteFormGroup.get(this.operacionesDelClienteJuridicoQuestions.tipos_de_operaciones_a_realizar).value),

        busca_alternativas_financiamiento:
          this.operacionesDelClienteFormGroup.get(this.operacionesDelClienteJuridicoQuestions.busca_alternativas_financiamiento).value,

        estado_cuenta_e_informacion_operaciones:
          this.operacionesDelClienteFormGroup.get(this.operacionesDelClienteJuridicoQuestions.estado_cuenta_e_informacion_operaciones).value,

        modalidad_envio_ordenes:
          JSON.stringify(this.operacionesDelClienteFormGroup.get(this.operacionesDelClienteJuridicoQuestions.modalidad_envio_ordenes).value),

      }


      this._Register.updateOperacionesDelClienteJuridico(operacionesDelClienteToUpdate).subscribe(

        (resp: OperacionesDelClienteJuridicoData) => {

          this.showStepInformacionPatrimonial = true;

          Swal.fire(
            "Se actualizó el formulario operaciones del cliente",
            "",
            "success"
          );

          setTimeout(() => {
            this.myStepper.next();
          }, 10);

        },
        (error) => {
          console.log("Ha ocurrido un error!");

          console.log(error);

          //TODO: Consultar con daniel si estan las validadciones del backend porque esta permitiendo enviar objetos vacios.
          Swal.fire("Ha ocurrido un error al intentar actualizar las operaciones de cliente", "", "warning");

        }
      )





    }


  }


  saveVinculadosAlCliente() {
    // this.eventoSiguienteTree()

    if (this.dataAccionista.length < 1) {
      Swal.fire("Debe agregar accionistas", "", "warning");
      //TODO: Mejorar mensaje
      return;
    }

    if (this.dataPersonaJur.length < 1) {
      Swal.fire("Debe agregar persona juridica", "", "warning");
      //TODO: Mejorar mensaje

      return;
    }








    const vinculadosAlClienteToUpdate = {
      informacion_vinculados_al_cliente: JSON.stringify(this.dataPersonaJur),
      relacion_personas_juridicas_vinculadas_al_cliente: JSON.stringify(this.dataAccionista)
    }


    this._Register.updateVinculadosAlCliente(vinculadosAlClienteToUpdate).subscribe(
      (resp) => {

        this.showPersonasAutorizadas = true;

        Swal.fire(
          "Se actualizó el formulario vinculados al cliente",
          "",
          "success"
        );

        setTimeout(() => {
          this.myStepper.next();
        }, 10);

      },
      (error) => {
        console.log("Ha ocurrido un error!");

        console.log(error);

        //TODO: Consultar con daniel si estan las validadciones del backend porque esta permitiendo enviar objetos vacios.
        Swal.fire("Ha ocurrido un error al intentar actualizar las operaciones de cliente", "", "warning");

      }
    )



  }

  saveTreeForm() {
    var validar = this.eventoSiguienteTree();

    if (validar) {
      let data = {
        ingreso_promedio_mensual: this.treeFormGroup.get("questtwo").value,
        inf_financiera_ultimo_ejercicio:
          this.treeFormGroup.get("questtree").value,
        procedencia_fondos: JSON.stringify(
          this.treeFormGroup.get("questfour").value
        ),
        usted_o_accionistas_investigado_delito:
          this.treeFormGroup.get("questfive").value,
        informacion_vinculados_al_cliente: JSON.stringify(this.dataAccionista),
        relacion_personas_juridicas_vinculadas_al_cliente: JSON.stringify(
          this.dataPersonaJur
        ),
      };


      this._Register.editTreeFormJuridico(data).subscribe(
        (response: any) => {
          this.apa5 = true;
          Swal.fire(response.statusMessage, "", "success");

          setTimeout(() => {
            this.myStepper.next();
          }, 10);
        },
        (error) => {
          Swal.fire(
            "Se actualizó el formulario operaciones del cliente",
            "",
            "warning"
          );
          return;
        }
      );
    } else {
      return;
    }
  }

  saveTwoForm() {
    var validar = this.eventoSiguienteTwo();
    if (validar) {
      let data = {
        fecha_inicio_actividades: this.secondFormGroup.get("questone").value,
        ciuu: this.secondFormGroup.get("questtwo").value,
        pais_desarrollo_actividad_principal:
          this.secondFormGroup.get("questtree").value,
        obligado_informar_uif_peru: this.secondFormGroup.get("questfour").value,
        designo_a_su_oficial_de_cumplimiento:
          this.secondFormGroup.get("questfive").value,
        tipos_de_operaciones_a_realizar: JSON.stringify(
          this.secondFormGroup.get("questnine").value
        ),
        modalidad_envio_ordenes: JSON.stringify(
          this.secondFormGroup.get("questten").value
        ),
        estado_cuenta_e_informacion_operaciones:
          this.secondFormGroup.get("questeleven").value,
        busca_alternativas_financiamiento:
          this.secondFormGroup.get("questtwelve").value,
        esta_vinculado_a_ind: this.secondFormGroup.get("questsix").value,
        representante_o_funcionario_otra_sab:
          this.secondFormGroup.get("questseven").value,
        inversionista_institucional:
          this.secondFormGroup.get("questeight").value,
      };


      this._Register.editTwoFormJuridico(data).subscribe(
        (response: any) => {

          this.showStepOperacionesDelClienteJuridico = true;
          Swal.fire(
            "Se actualizó el formulario actividad del cliente",
            "",
            "success"
          );

          setTimeout(() => {
            this.myStepper.next();
          }, 10);
        },
        (error) => {
          Swal.fire(error.error.statusMessage, "", "warning");
          return;
        }
      );
    } else {
      return;
    }

    /*   this.apa4 = true;
     */
  }

  saveOneForm() {
    var validar = this.eventSiguiente();
    if (validar) {
      let data = {
        razon_social: this.firstFormGroup.get("razSoc").value,
        administrador: this.firstFormGroup.get("admin").value,
        tipo_documento: this.firstFormGroup.get("tipDoc").value,
        registro_de_personas_juridicas:
          this.firstFormGroup.get("regPerJur").value,
        partida_registral: this.firstFormGroup.get("parReg").value,
        pais_de_constitucion: this.firstFormGroup.get("paisToCons").value,
        pagina_web: this.firstFormGroup.get("pagWeb").value,
        nro_documento: this.firstFormGroup.get("numDoc").value,
        correo: this.firstFormGroup.get("email").value,
        direccion: this.firstFormGroup.get("dirDom").value,
        departamento: this.firstFormGroup.get("depar").value,
        provincia: this.firstFormGroup.get("prov").value,
        distrito: this.firstFormGroup.get("distri").value,
        pais: this.firstFormGroup.get("pais").value,
        codigo_postal: this.firstFormGroup.get("codPos").value,
        celular: this.firstFormGroup.get("celu").value,
        telefono_fijo: this.firstFormGroup.get("telFijo").value,
      };

      this._Register.editOneFormJuridico(data).subscribe(
        (response: any) => {
          this.apa3 = true;
          Swal.fire(
            "Se actualizó el formulario identificación del cliente",
            "",
            "success"
          );


          setTimeout(() => {
            this.myStepper.next();
          }, 10);
        },
        (error) => {
          Swal.fire(error.error.statusMessage, "", "warning");
          return;
        }
      );
    } else {
      return;
    }
  }

  triggerClick() {
    if (this.Indice == 1) {

      this.apa3 = true;
    }
    if (this.Indice == 2) {
      this.apa4 = true;
    }
    if (this.Indice == 3) {
      this.apa5 = true;
    }
  }

  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }
  formSubmitted = false;
  customYearValues = [2006, 1970];

  lettersOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 33 || charCode > 64)) {
      return true;
    }
    return false;
  }


  cargarDataFourFormJuridico() {
    this._Register.getFourFormJuridico().subscribe((data) => {
      this.dataFour = data.data;

      if (data.data.vinculo_con_la_pj_detalle != null) {
        this.dataFinal = JSON.parse(data.data.vinculo_con_la_pj_detalle);
      }
      this.fourFormGroup = this._formBuilder.group({
        questone: [this.dataFour.vinculo_con_la_pj, Validators.required], //ya
        questtwo: [this.dataFinal.nombre, Validators.required], //ya
        questtree: [this.dataFinal.apellidos, Validators.required], //ya
        questfour: [this.dataFinal.fecha_nacimiento, Validators.required], //ya
        questfive: [this.dataFinal.tipo_documento, Validators.required], //ya
        questsix: [this.dataFinal.nro_documento, Validators.required], //ya
        questseven: [this.dataFinal.nacionalidad, Validators.required], //ya
        questeight: [this.dataFinal.pais_nacimiento, Validators.required], //ya
        questnine: [this.dataFinal.direccion, Validators.required], //ya
        questten: [this.dataFinal.estado_civil, Validators.required], //ya
        questeleven: [this.dataFinal.departamento, Validators.required], //ya
        questtwelve: [this.dataFinal.provincia, Validators.required], //ya
        questthirteen: [this.dataFinal.distrito, Validators.required], //ya
        questfourteen: [this.dataFinal.pais, Validators.required], //ya
        questfivteen: [this.dataFinal.codigo_postal, Validators.required], //ya
        questsixteen: [this.dataFinal.celular, Validators.required], //ya
        questseventeen: [this.dataFinal.telefono_fijo, Validators.required], //ya
        questeighteen: [this.dataFinal.correo, Validators.required], //ya
        questtwuelve: [this.dataFinal.fecha_poder, Validators.required], //ya
        questtwuelveone: [
          this.dataFinal.partida_registral,
          Validators.required,
        ], //ya
        questtwuelvetwo: [
          this.dataFinal.expuesto_politicamente_o_pertenece_pep,
          Validators.required,
        ], //ya
        questtwuelvetree: [
          this.dataFinal.registro_personas_juridicas,
          Validators.required,
        ], //ya
        questtwuelvefour: [this.dataFinal.p_o_pep_nombres, Validators.required], //ya
        questtwuelvefive: [
          this.dataFinal.p_o_pep_apellidos,
          Validators.required,
        ], //ya
        questtwuelvesix: [
          this.dataFinal.p_o_pep_nombre_institucion,
          Validators.required,
        ], //ya
        questtwuelveseven: [this.dataFinal.p_o_pep_cargo, Validators.required], //ya
      });


      this.isLoadinData = false;
    });

  }


  cargarDataFormVinculadosAlCliente() {
    this._Register.getVinculadosAlCliente().subscribe(
      (vinculadaAlClienteJuridicoData) => {

        this.treeFormGroup = this._formBuilder.group({})

        this.vinculadosAlClienteData = vinculadaAlClienteJuridicoData;

        this.dataPersonaJur = vinculadaAlClienteJuridicoData.data.informacion_vinculados_al_cliente ?
          JSON.parse(vinculadaAlClienteJuridicoData.data.informacion_vinculados_al_cliente) : [];


        this.dataAccionista = vinculadaAlClienteJuridicoData.data.relacion_personas_juridicas_vinculadas_al_cliente ?
          JSON.parse(vinculadaAlClienteJuridicoData.data.relacion_personas_juridicas_vinculadas_al_cliente) : [];

      },
      (error) => {
        console.log("Ha ocurrido un error!");
        console.log(error);
      }
    )
  }



  cargarDataFormInformacionPatrimonial() {

    this._Register.getInformacionPatrimonial().subscribe(
      (informacionPatrimonialData) => {

        this.informacionPatrimonialData = informacionPatrimonialData;

        this.informacionPatrimonialFormGroup =
          this._formBuilder.group({
            question_ingreso_promedio_mensual: [this.informacionPatrimonialData.data.ingreso_promedio_mensual, Validators.required],

            question_financiera_ultimo_ejercicio: [this.informacionPatrimonialData.data.inf_financiera_ultimo_ejercicio, Validators.required],

            question_procedencia_fondos: [JSON.parse(this.informacionPatrimonialData.data.procedencia_fondos), Validators.required],

            question_usted_o_accionistas_investigado_por_delito: [this.informacionPatrimonialData.data.usted_o_accionistas_investigado_delito, Validators.required],

          });

      },
      (error) => {
        console.log("Ha ocurrido un error!");
        console.log(error);
      }
    );
  }


  cargarDataFormOperacionesDelClienteJuridico() {


    this._Register.getOperacionesDelClienteJuridico().subscribe(
      (operacionesDelClienteJuridicoData) => {


        this.operacionesDelClienteJuridicoData = operacionesDelClienteJuridicoData;

        this.operacionesDelClienteFormGroup = this._formBuilder.group({

          question_tipos_operacion_realizar: [
            JSON.parse(operacionesDelClienteJuridicoData.data.tipos_de_operaciones_a_realizar), Validators.required],

          question_alternativas_de_financiamiento: [
            this.operacionesDelClienteJuridicoData.data.busca_alternativas_financiamiento, Validators.required],

          question_modalidad_de_envio_de_ordenes: [
            JSON.parse(this.operacionesDelClienteJuridicoData.data.modalidad_envio_ordenes), Validators.required],

          question_acceso_estado_de_cuenta_e_informacion_de_operaciones: [
            this.operacionesDelClienteJuridicoData.data.estado_cuenta_e_informacion_operaciones, Validators.required,
          ],
        });
      });

  }
}
